import { render, staticRenderFns } from "./Web.vue?vue&type=template&id=6049bf47&scoped=true"
import script from "./Web.vue?vue&type=script&lang=js"
export * from "./Web.vue?vue&type=script&lang=js"
import style0 from "./Web.vue?vue&type=style&index=0&id=6049bf47&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6049bf47",
  null
  
)

export default component.exports